import { createApp } from 'vue'
import i18n from '@/i18n';
import {createBootstrap} from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import { createPinia } from 'pinia';
import router from '@/router';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

import 'flag-icons/css/flag-icons.min.css';
import '@/assets/css/flag-corsica.css';
import '@/assets/css/logo.css';

import { getLogoDirByHost } from './utils/getLogoDir';
import { loadThemeByHost } from './utils/loadTheme';

import App from '@/App.vue';

const app = createApp(App);

app.component('VueDatePicker', VueDatePicker);
app.use(createPinia());
app.use(router);
app.use(i18n);

const globalOptions = {
  mode: 'international',
  defaultCountry: 'FR',
  onlyCountries: ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GP','MQ','GF','RE','YT','BL','MF','PM','WF','PF','NC','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','CH']
};

loadThemeByHost();
app.config.globalProperties.$logoDir = getLogoDirByHost();

app.use(VueTelInput, globalOptions);

if (process.env.NODE_ENV === 'production') {
  app.config.productionTip = false;
  app.config.devtools = false;
}

app.use(createBootstrap());

app.mount('#app');
